import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { RequestDreForm } from 'pages/financeiro/dre/types';

export function useQueryDre() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery<RequestDreForm>(['queryDre'], () =>
        requestListagem({
            url: `/dre/dremercadologicawrapper/${id}`,
        }).then((res) => res),
    );
}
